import React from "react";
import { ds } from "../../DataSource";
import { ParentStateDatasource, DataSourceStateIdle } from "@schneiderpp/utils-endpoint";
import { Endpoint } from "@schneiderpp/admin-endpoint";
import { ROUTER_HOME } from "../home/Router";
import { BaseComponent } from "../../utils/BaseComponent";
import { RouteComponentProps, Link, withRouter } from "react-router-dom";
import { OverlayProps, Overlay } from "@schneiderpp/utils-components";

interface DeleteState {
    providedProductId: number | undefined;
    datasource: {
        Details: ParentStateDatasource<typeof Endpoint.Product.GetProductDetails>;
        Delete: ParentStateDatasource<typeof Endpoint.Product.PostProductDelete>;
    };
}

class ProductDelete extends BaseComponent<RouteComponentProps, DeleteState> {
    state: DeleteState = {
        providedProductId: undefined,
        datasource: {
            Details: DataSourceStateIdle,
            Delete: DataSourceStateIdle
        }
    };

    private dsDetails = ds(Endpoint.Product.GetProductDetails, this, "Details", () => this.context);

    private dsDelete = ds(Endpoint.Product.PostProductDelete, this, "Delete", () => this.context);

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const ProductId = urlParams.get("ProductId");
        if (!ProductId) {
            return;
        }
        const ProductIdInt = parseInt(ProductId);
        if (!Number.isInteger(ProductIdInt)) {
            return;
        }
        this.setState({ providedProductId: ProductIdInt }, () => this.getDetails());
    }

    render() {
        if (!this.state.providedProductId) {
            return (
                <div className="page">
                    <div className="page__header">Nie odnaleziono ProductID</div>
                </div>
            );
        }
        const dsDetails = this.dsDetails.dataSourceStorage;
        if (dsDetails.state === "completed") {
            return (
                <>
                    <div className="header">
                        {" "}
                        <Link
                            to={{ pathname: ROUTER_HOME.Products.Details, search: `ProductId=${this.state.providedProductId}` }}
                            className="button clear no-left-padding"
                        >
                            <span className="button__icon">arrow_back_ios</span> wróć do Detali produktu
                        </Link>
                    </div>
                    <div className="page">
                        <div className="page__header">Usuń produkt</div>
                        <div className="page-details">
                            <div className="page-details__label">Nazwa</div>
                            <div className="page-details__value">{dsDetails.response.Name}</div>
                        </div>
                        <div className="page-form">
                            <button className="button align-self-end margin-top-10" onClick={() => this.submit()}>
                                usuń
                            </button>
                        </div>
                        <Overlay {...this.overlayProps} />
                    </div>
                </>
            );
        }
        return (
            <div className="page">
                <Overlay {...this.overlayProps} />
            </div>
        );
    }

    get overlayProps(): OverlayProps {
        if (this.dsDetails.state === "pending" || this.dsDetails.state === "idle" || this.dsDelete.state === "pending") {
            return {
                show: true,
                title: "Ładowane..."
            };
        }
        if (this.dsDetails.state === "error") {
            return {
                show: true,
                title: "Coś poszło nie tak",
                description: typeof this.dsDetails.error === "string" ? this.dsDetails.error : "",
                children: (
                    <div className="overlay__children">
                        <button onClick={() => this.getDetails()}>Spróbuj ponownie</button>
                    </div>
                )
            };
        }
        if (this.dsDelete.state === "error") {
            return {
                show: true,
                title: "Coś poszło nie tak",
                description: typeof this.dsDelete.error === "string" ? this.dsDelete.error : "",
                children: (
                    <div className="overlay__children">
                        <button onClick={() => this.dsDelete.resetState()}>Spróbuj ponownie</button>
                    </div>
                )
            };
        }
        return {
            show: false
        };
    }

    private async submit() {
        if (!this.state.providedProductId) {
            return;
        }
        await this.dsDelete.request({
            data: {
                ProductId: this.state.providedProductId
            }
        });
        if (this.dsDelete.dataSourceStorage.state === "completed") {
            this.props.history.push({ pathname: ROUTER_HOME.Products.List });
        }
    }

    private async getDetails() {
        if (!this.state.providedProductId) {
            return;
        }
        await this.dsDetails.request({
            params: { ProductId: this.state.providedProductId }
        });
    }
}

export default withRouter(ProductDelete);
